import React from 'react';
import { isMobile } from 'react-device-detect';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { BackButton, InteractiveButton } from '../../../../components';
import Processing from '@/presentation/components/Processing';
import {
  ToggleHeader,
  TextTitle
} from '../../../certificates-constancies/type1/register/components';
import CardPayment from '../../Reincorporation/progress/components/CardPayment';
import Step from '../../UpdatePhoto/Register/components/Step';
import { Block, Text } from '../../../../../../components';
import { evalStatus } from './utils';
import InfoComponent from '../info/components/InfoComponent';
import Spinner from '@/presentation/components/Spinner';
import CancelProcedure from '../../CertificateOfStudies/dialogs/CancelProcedure';
import PaymentCreated from '../../CertificateOfStudies/dialogs/PaymentCreated';
import CardProgress from '@/presentation/reusables/CardProgress';
import {
  documentSuccessDskImage,
  documentSuccessImage
} from '@/presentation/modules/procedures/components/Images';
import AnulledFinalState from '../../RetreatCourse/progress/components/AnulledFinalState';

interface Props {
  handlerBackButton: () => void;
  request: any;
  procedure: any;
  isLoadingStatus: boolean;
  isLoadingDetail: boolean;
  handlerCancelProcedure: () => void;
  handlerActivatePayment: () => void;
  payment: {
    showModalPayment: boolean;
    setShowModalPayment: (value: boolean) => void;
  };
  anulatedPayment: {
    showModalAnuledPayment: boolean;
    setShowModalAnuledPayment: (value: boolean) => void;
  };
  isLoadingCancel: boolean;
  isLoadingActivatePayment: boolean;
  isPaymentDone: boolean;
  isSuccessActivatePayment: boolean;
  isPaymentActive: boolean;
  handlerDownload: () => void;
}

const GraduatedCertificatedProgressView: React.FC<Props> = (props) => {
  const { handlerBackButton, request, procedure } = props;
  const { isLoadingStatus, isLoadingDetail, handlerCancelProcedure } = props;
  const { handlerActivatePayment, payment, anulatedPayment } = props;
  const { showModalPayment, setShowModalPayment } = payment;
  const { showModalAnuledPayment, setShowModalAnuledPayment } = anulatedPayment;
  const { isLoadingCancel, isLoadingActivatePayment, isPaymentDone } = props;
  const { isSuccessActivatePayment, isPaymentActive, handlerDownload } = props;

  return (
    <ContainerProcedure>
      <SubContainer>
        <BackButton onClick={handlerBackButton} />
      </SubContainer>
      <br />
      <Processing isOpen={isLoadingCancel || isLoadingActivatePayment} />
      {(isLoadingStatus || isLoadingDetail || !request) && <Spinner />}
      {request && (
        <SubContainer>
          <ToggleHeader
            isMigrated={procedure?.detail?.isMigrated}
            name={procedure?.name}
            amount={procedure?.amount}
            duration={procedure?.duration}
            date={procedure?.endDate}
            status={request?.status}
            childContent={
              <InfoComponent
                steps={procedure?.stepsToFollow}
                inRegister
                setShowModel={() => {}}
              />
            }
          />
          <TextTitle title="Progreso" />
          <Block customized padding="28px 0px 45px 8px">
            <Step
              isFirst
              name={procedure?.steps[0].name}
              order={procedure?.steps[0].order}
              date={procedure?.steps[0].date?.toLowerCase()}
              isComplete
              isCurrent={procedure?.steps[0].isCurrent}
            >
              <div>
                <p>Datos validados para tu constancia:</p>
                <ul>
                  <li>Nombres y apellidos: Luis Alberto Carpio Terrones</li>
                  <li>Carrera: Ingeniería de sistemas e informática</li>
                </ul>
              </div>
            </Step>
            <Step
              name={procedure?.steps[1]?.name}
              order={procedure?.steps[1]?.order}
              isComplete={
                request?.status.status === 'FINALIZADO' ||
                request?.status.status === 'PROCEDE'
              }
              disabled={
                evalStatus(request)?.name === 'ANULADO' ||
                request.status.status === 'NO_PROCEDE'
              }
            >
              {evalStatus(request)?.name === 'CREADO' && (
                <CardPayment
                  title="Genera el cargo de tu trámite activando tu pago"
                  infoText="Recuerda que una vez realizado el pago, se procederá con tu solicitud."
                  buttonText="Activar"
                  isPaymentActive={isPaymentActive}
                  isPaymentDone={isPaymentDone}
                  handlerActivatePayment={handlerActivatePayment}
                  isLoadingActivatePayment={false}
                  isSuccessActivatePayment={false}
                  firstDialogSubtitle={`Al aceptar, se cargará el monto de S/${procedure?.amount}.00 a tus pagos pendientes.`}
                />
              )}
              {evalStatus(request)?.name === 'PAGO_ACTIVADO' &&
                !isPaymentDone && (
                  <CardPayment
                    title="El pago ha sido activado"
                    infoText="La actualización del estado puede tardar aproximadamente 30 minutos tras el pago. Luego, comenzaremos a procesar tu solicitud."
                    buttonText="Ir a pagos"
                    isPaymentActive
                    isPaymentDone={isPaymentDone}
                    handlerActivatePayment={handlerActivatePayment}
                    isLoadingActivatePayment={false}
                    isSuccessActivatePayment={isSuccessActivatePayment}
                    secondDialogSubtitle={
                      'Ya se encuentra disponible tu pago. Recuerda que una vez realizado el pago procederá tu solicitud.'
                    }
                  />
                )}
            </Step>
            <Step
              name={procedure?.steps[2]?.name}
              order={procedure?.steps[2]?.order}
              isComplete={
                request?.status.status === 'FINALIZADO' ||
                request?.status.status === 'PROCEDE'
              }
              disabled={
                evalStatus(request)?.name === 'ANULADO'
                  ? false
                  : !procedure.steps[2].isCurrent
              }
              isLast
            >
              {evalStatus(request)?.name === 'PROCEDE' && (
                <>
                  <p>{procedure?.steps[2]?.date}</p>
                  <CardProgress
                    image={[documentSuccessImage, documentSuccessDskImage]}
                    title={`Tu constancia está lista`}
                  >
                    <div style={{ textAlign: 'left' }}>
                      <p>
                        El documento se ha generado con éxito. Recuerda que la
                        descarga estará vigente por <b>30 días.</b>
                      </p>
                    </div>
                    <InteractiveButton
                      bkgColorEnabled="#5B36F2"
                      bkgColorHover="#745EF6"
                      bkgColorFocus="#4318CD"
                      bkgColorPressed="#4318CD"
                      customized
                      alignItems="center"
                      backgroundColor="#5B36F2"
                      padding="10px 0px"
                      borderRadius="4px"
                      width="100%"
                      onClick={handlerDownload}
                    >
                      <Text
                        color="#FFFFFF"
                        fontSize="14px"
                        lineHeight="20px"
                        fontWeight="700"
                        textAlign="center"
                      >
                        {'Descargar'}
                      </Text>
                    </InteractiveButton>
                  </CardProgress>
                </>
              )}

              {evalStatus(request)?.name === 'ANULADO' && (
                <AnulledFinalState procedure={procedure} />
              )}
            </Step>
          </Block>
          {evalStatus(request)?.name !== 'ANULADO' && (
            <Block style={{ alignSelf: isMobile ? 'center' : 'flex-start' }}>
              <InteractiveButton
                bkgColorEnabled="none"
                bkgColorHover="#E2DFFD"
                bkgColorFocus="#C6C0FC"
                bkgColorPressed="#C6C0FC"
                customized
                border="1px solid #5B36F2"
                alignItems="center"
                backgroundColor="#FFFFFF"
                padding="9px 0px"
                margin={isMobile ? '12px 0px 20px 0px' : '0px 0px 20px 0px'}
                borderRadius="4px"
                width="130px"
                justifyContent={isMobile ? 'center' : 'flex-start'}
                display="flex"
                onClick={() => setShowModalAnuledPayment(true)}
              >
                <Text
                  color="#5B36F2"
                  fontSize="14px"
                  lineHeight="20px"
                  fontWeight="700"
                  textAlign="center"
                  width="150px"
                >
                  Anular solicitud
                </Text>
              </InteractiveButton>
            </Block>
          )}
          <CancelProcedure
            handlerCancelProcedure={handlerCancelProcedure}
            handlerClose={() => setShowModalAnuledPayment(false)}
            show={showModalAnuledPayment}
          />
          <PaymentCreated
            show={showModalPayment}
            handlerOnNext={handlerBackButton}
            handlerClose={() => setShowModalPayment(false)}
          />
        </SubContainer>
      )}
    </ContainerProcedure>
  );
};

export default GraduatedCertificatedProgressView;
